import { safeParse } from '../src/helpers/json';

export const FEATURES = {
  dtcp: 'DTCP',
};

export const enableFeature = featureName => {
  const stringFeatureList = process.env.GATSBY_ENABLE_FEATURE;
  if (!stringFeatureList) return false;

  const featureList = safeParse(stringFeatureList, null);
  if (!featureList) return false;

  const allFeatures = Object.values(FEATURES);
  const canEnable =
    featureList.includes(featureName) && allFeatures.includes(featureName);
  return canEnable;
};
